import axios from 'axios'
export const getPhoneVerifyTable = (queryparams) => axios.get(`virgo/fe/3f/supplier/ivr/phone/query`, {
    params: Object.assign({feclient: 'lvyou_web'}, queryparams)
})

export const unbindPhone = (queryparams) => axios.delete(`virgo/fe/3f/supplier/ivr/phone/delete`, {
    params: Object.assign({feclient: 'lvyou_web'}, queryparams)
})

export const bindPhone = (data) => {
    const url = `virgo/fe/3f/supplier/ivr/phone/add`;
    return axios.post(url, data, {
        params: {
            feclient: 'lvyou_web',
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/phoneVerify.js